
<div>
    <a @click="onClick">
        <div class="title-info" style="margin-left: 2px; margin-right: 2px;">
            <div class="v-flex" style="margin-top: -2px"  v-if="state">
                <div>Wartung {{ state.required }} x p.a.</div>
                <div
                    class="ml-2 pl-1 pr-1"
                    :class="state.current !== state.required ? 'error' : 'success'"
                >
                    {{ state.current }} x in {{ state.year }}
                </div>
            </div>
            <div style="margin-top: -2px;" v-if="last">Letzte Wartung: {{ last }}</div>
        </div>
    </a>
</div>
